import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../../../constants/componentTypes";
import * as navigationActions from "../../../../../actions/navigationActions";

class NoteModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseNoteModalAction();
    };

    render() {
        return (
            <div id="modal" className="set-canister-level fill-canister-history note-modal">
                <header className="color-primary">
                    <Translate value="general.note" />
                </header>
                <div className="modal-content set-canister-level-content">
                    <div className="col-xs-12">{this.props.params.note}</div>
                </div>
                <div className="col-xs-12 text-right modal-footer">
                    <button className="btn btn-danger btn-arrow" onClick={this.handleCloseModalClick}>
                        Close
                    </button>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        machine: store.rcc.machine
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseNoteModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_NOTE_MODAL));
        }
    };
};

export default NoteModal = connect(mapStoreToProps, mapDispatchToProps)(NoteModal);
